export const ZOHO_SCOPES = [
  "ZohoCRM.users.CREATE",
  "ZohoCRM.users.READ",
  "ZohoCRM.users.UPDATE",
  "ZohoCRM.org.READ",
  "ZohoCRM.org.UPDATE",
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.settings.READ",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.CREATE",
  "ZohoCRM.modules.READ",
  "ZohoCRM.modules.UPDATE",
];
